module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navigation",
    class: {
      'navigation--scrolled': _vm.$store.state.nav || _vm.menu
    }
  }, [_c('div', {
    staticClass: "navigation__container navigation__desktop"
  }, [_c('div', {
    staticClass: "navigation__icon",
    on: {
      "click": function($event) {
        _vm.resetNavBg()
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('Icon', {
    attrs: {
      "name": "logo-coo"
    }
  })], 1)], 1), _c('div', {
    staticClass: "navigation__icon navigation__icon--option",
    on: {
      "click": function($event) {
        _vm.resetNavBg()
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('Icon', {
    attrs: {
      "name": "logo-coo-options"
    }
  })], 1)], 1), _c('div', {
    staticClass: "navigation__links"
  }, _vm._l((_vm.props), function(nav) {
    return (nav.navigation) ? _c('span', {
      staticClass: "navigation__link",
      on: {
        "click": function($event) {
          _vm.resetNavBg()
        }
      }
    }, [_c('router-link', {
      attrs: {
        "to": nav.path
      }
    }, [_c('a', [_vm._v(_vm._s(nav.name))])])], 1) : _vm._e()
  }))]), _c('div', {
    staticClass: "navigation__container navigation__mobile"
  }, [_c('div', {
    staticClass: "navigation__icon",
    on: {
      "click": function($event) {
        _vm.menu = false
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('Icon', {
    attrs: {
      "name": "logo-coo"
    }
  })], 1), _c('div', {
    staticClass: "navigation__phone navigation__phonewhite"
  }, [_c('a', {
    attrs: {
      "href": _vm.propsFooter.props.acf.footer.phone_link
    }
  }, [_c('Icon', {
    attrs: {
      "name": "Phone"
    }
  }), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.propsFooter.props.acf.footer.phone_number)
    }
  })], 1)])], 1), _c('div', {
    staticClass: "navigation__icon navigation__icon--option",
    on: {
      "click": function($event) {
        _vm.menu = false
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('Icon', {
    attrs: {
      "name": "logo-coo-options"
    }
  })], 1), _c('div', {
    staticClass: "navigation__phone"
  }, [_c('a', {
    attrs: {
      "href": _vm.propsFooter.props.acf.footer.phone_link
    }
  }, [_c('Icon', {
    attrs: {
      "name": "Phone"
    }
  }), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.propsFooter.props.acf.footer.phone_number)
    }
  })], 1)])], 1), _c('div', {
    staticClass: "navigation__menu",
    on: {
      "click": function($event) {
        _vm.menu ? _vm.menu = false : _vm.menu = true
      }
    }
  }, [_vm._v("MENU")])]), (_vm.menu) ? _c('div', {
    staticClass: "navigation__container navigation__mobile navigation__links--mobile"
  }, [_vm._l((_vm.props), function(nav) {
    return (nav.navigation) ? _c('div', {
      staticClass: "navigation__link navigation__link--mobile",
      on: {
        "click": function($event) {
          _vm.menu = false
        }
      }
    }, [_c('router-link', {
      attrs: {
        "to": nav.path
      }
    }, [_vm._v(_vm._s(nav.name))])], 1) : _vm._e()
  }), _c('div', {
    staticClass: "navigation__link navigation__link--mobile navigation__button",
    on: {
      "click": function($event) {
        _vm.showComplimentaryModal = true, _vm.menu = false
      }
    }
  }, [_vm._v("Complimentary Exam")])], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eb47e560","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/navigation/navigation.pug
// module id = 602
// module chunks = 1